import { MessageCircle } from "lucide-react";
import { CONTACT } from "../../data/content";

export const WhatsAppButton = () => {
  const wa = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Hola JAN SMM, me gustaría más información.")}`;
  return (
    <a
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 grid place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/40 hover:scale-110 transition-transform"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <MessageCircle size={26} className="relative" />
    </a>
  );
};
